import gql from 'graphql-tag';

// Reads enum value names via the purpose-built public `enumValues` query instead
// of the `__type` introspection meta-field, so the API can disable introspection
// on live (Phase 3 GraphQL hardening). The shape returned to callers is
// unchanged — an array of { name } — so EnumValues.js consumers are untouched.
const introspectionQueries = {
  EnumValues: (enumName) => {
    return gql`
      query {
        enumValues(name: "${enumName}") {
          name
        }
      }`;
  }
};

export default introspectionQueries;
